/*
 * Copyright (c) 2019-2021 LogMeIn
 * All Rights Reserved Worldwide.
 *
 * THIS PROGRAM IS CONFIDENTIAL AND PROPRIETARY TO LOGMEIN
 * AND CONSTITUTES A VALUABLE TRADE SECRET.
 */

import React, { useContext } from 'react';
import { defineMessages, useIntl } from 'react-intl';
import { Flex, Image, Text } from '@getgo/chameleon-chakra-ui';

import { SessionContext } from '../../../context/SessionContext';
import { Link } from '../../../components/Link/Link';
import { FlowType } from '../../../services/IndexPageReaderService';
import {
  TelemetryAction,
  TelemetryComponent,
  TelemetryState,
  useSendTelemetry,
} from '../../../hooks/useSendTelemetry';

const messages = defineMessages({
  headingJoin: {
    id: 'ongoing.heading.join',
  },
  headingInstall: {
    id: 'ongoing.heading.install',
  },
  description: {
    id: 'ongoing.description',
  },
  troubleshooting: {
    id: 'ongoing.troubleshooting',
  },
  tryAgainLink: {
    id: 'ongoing.tryAgainLink',
  },
});

interface Props {
  onTryAgain: () => void;
}

export const G2MOngoing: React.FC<Props> = ({ onTryAgain }) => {
  const sendTelemetry = useSendTelemetry();
  const { flowType } = useContext(SessionContext);
  const { formatMessage: f } = useIntl();

  return (
    <Flex
      direction='column'
      justifyContent='center'
      alignItems='center'
      id='ongoingStatus'
      pb='10vh'
    >
      <Text as='h1'>
        {f(
          flowType === FlowType.Join
            ? messages.headingJoin
            : messages.headingInstall
        )}
      </Text>
      <Image
        my='1.875rem'
        src={`${process.env.PUBLIC_URL}/static/media/daisy-check.svg`}
        alt='GoToMeeting'
        aria-hidden='true'
      />
      <Text mt='0.75rem' mb='1.875rem'>
        {f(messages.description)}
      </Text>
      <Text mt='0.75rem' mb='1.875rem'>
        {f(messages.troubleshooting)}{' '}
        <Link
          textDecoration='underline'
          href=''
          onClick={() => {
            sendTelemetry(
              TelemetryComponent.Native,
              TelemetryAction.Retry,
              TelemetryState.Ongoing
            );
            onTryAgain();
          }}
        >
          {f(messages.tryAgainLink)}
        </Link>
      </Text>
    </Flex>
  );
};
